import React from "react";
import {connect} from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import AssignmentInd from "@material-ui/icons/AssignmentInd";

import styles from "assets/jss/material-dashboard-pro-react/views/form";

import {subProfileSave, subProfileFetch} from 'actions/subProfiles'

import {
  danger,
} from 'actions/notification'

class Platforms extends React.Component {
  button = React.createRef()
	state = {
		form: {
      name: ''
    },
    goToNext: true
  }
  componentDidUpdate(prevProps, prevState){
    if (prevProps.additionalWizardData !== this.props.additionalWizardData) {
      this.setData()
    }
    if (prevProps.changeStep !== this.props.changeStep) {
      // handle submit action
      if(this.props.stepDataObject.stepId === this.props.changeStep.currentStep.stepId){
        this.button.current.click()
        this.props.navigationStepChange(this.props.changeStep.nextStep.key)
        this.setState({...this.state, goToNext: false})
      }
    }
  }
  setData(){
    const {subProfile} = this.props.additionalWizardData
    if(subProfile){
      this.props.saveWizardData(subProfile)
      this.setState({
        ...this.state,
        form:{
        name: subProfile.name
      }
      })
    }
  }
	change(event,name){
    this.setState({
      ...this.state,
      form:{
        ...this.state.form,
        [name]:event.target.value
      },
    })
	}
	getInput(data){
    return   <CustomInput
        labelText={
          <span>
            {data.name} {(data.required?<small>*</small>: <small>(optional)</small>)}
          </span>
        }
        id={data.key}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          onChange: event => this.change(event, data.key),
          required:data.required,
          value:this.state.form[data.key] || '',
          type:data.type,
          endAdornment: (
            <InputAdornment
              position="end"
              className={this.props.classes.inputAdornment}
            >
              {data.icon}
            </InputAdornment>
          )
        }}
    />
	}
	submit(e){
    e.preventDefault()
    const history = this.props.history
    const match = this.props.match
    const editmode = match.params.id
    let data = {...this.props.wizardData, ...this.state.form}
    this.props.save(data)
      .then(e => {
        if(!editmode){
          history.push(`/administration/profiles/subprofile/${e.subProfileId}`)
          
        }
        this.props.saveWizardData(e)
        if(this.state.goToNext) this.props.goToNextStep()
      })
      .catch(e=>{this.props.danger(e+'',4);})
		
	}
  render() {
    const {classes} = this.props
    //console.log(this.state.form)
  	return (
			<form onSubmit={(e) => this.submit(e)}>
				<GridContainer justify="center">
					<GridItem xs={12} sm={11} md={11}>
						{this.getInput({
							key:'name',
							name:'Name of Subprofile',
							icon:<AssignmentInd className={classes.inputAdornmentIcon}/>,
							type:'text',
							required:true
            })}

					</GridItem>

					<GridItem sm={11}>
						<div style={{float: 'right'}}>
              <button type='submit' ref={this.button} style={{visibility: 'hidden'}}></button>
							<Button
								color="success"
								type="button"
                style={{position:'absolute', bottom:'10px', right:'40px'}}
                onClick={()=> {
                  this.setState({...this.state, goToNext: true})
                  this.button.current.click()
                }}
							>
								Next
							</Button>
						</div>
					</GridItem>
				</GridContainer>
			</form>
  	);
  }
}
const state=(state)=>({
  profiles: state.profiles
})
const dispatch=(dispatch)=>({
  fetch:(id)=>dispatch(subProfileFetch(id)),
  save:(data)=>dispatch(subProfileSave(data)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
})
export default withStyles(styles)(connect(state,dispatch)(Platforms))



// WEBPACK FOOTER //
// ./src/views/Profiles/SubProfileWizard/Platforms.jsx